import React from 'react';
import { authRoles } from 'app/auth';

export const LandingPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/landing',
			component: React.lazy(() => import('./LandingPage'))
		}
	]
};
